import {
    WIDGET_PANEL_HEIGHT_PX,
    WIDGET_PANEL_WIDTH_PX,
} from './dimensions';

export const WIDGET_STYLE_ID = 'votiq-widget-styles';

export const WIDGET_CSS = `
#votiq-widget-root, #votiq-widget-root * { box-sizing: border-box; }
#votiq-widget-root {
  --votiq-panel-width: ${WIDGET_PANEL_WIDTH_PX}px;
  --votiq-panel-height: ${WIDGET_PANEL_HEIGHT_PX}px;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
#votiq-widget-root button { font: inherit; cursor: pointer; border: none; background: none; }
#votiq-widget-root .votiq-stack {
  position: fixed;
  z-index: 2147483000;
  display: flex;
  gap: 12px;
  pointer-events: none;
}
#votiq-widget-root .votiq-stack > * { pointer-events: auto; }
#votiq-widget-root .votiq-stack--bottom-right { right: 24px; bottom: 24px; flex-direction: column; align-items: flex-end; }
#votiq-widget-root .votiq-stack--bottom-left { left: 24px; bottom: 24px; flex-direction: column; align-items: flex-start; }
#votiq-widget-root .votiq-stack--top-right { right: 24px; top: 24px; flex-direction: column-reverse; align-items: flex-end; }
#votiq-widget-root .votiq-stack--top-left { left: 24px; top: 24px; flex-direction: column-reverse; align-items: flex-start; }
#votiq-widget-root .votiq-stack--left-middle {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  flex-direction: row;
  align-items: center;
}
#votiq-widget-root .votiq-stack--right-middle {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  flex-direction: row-reverse;
  align-items: center;
}
#votiq-widget-root .votiq-stack--left-bottom {
  left: 0;
  right: auto;
  bottom: 0;
  top: auto;
  transform: none;
  flex-direction: column;
  align-items: flex-start;
}
#votiq-widget-root .votiq-stack--right-bottom {
  right: 0;
  left: auto;
  bottom: 0;
  top: auto;
  transform: none;
  flex-direction: column;
  align-items: flex-end;
}
#votiq-widget-root .votiq-launcher {
  width: 56px; height: 56px; border-radius: 9999px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 28px rgba(0,23,21,0.18);
  transition: transform 0.2s;
}
#votiq-widget-root .votiq-launcher:hover { transform: scale(1.05); }
#votiq-widget-root .votiq-launcher--lime { background: #AAF775; color: #052D2B; }
#votiq-widget-root .votiq-launcher--dark { background: #001715; color: #AAF775; }
#votiq-widget-root .votiq-launcher--styled {
  box-shadow: 0 8px 28px rgba(0, 23, 21, 0.18);
}
#votiq-widget-root .votiq-launcher svg { width: var(--votiq-launcher-icon-size, 24px); height: var(--votiq-launcher-icon-size, 24px); }
#votiq-widget-root .votiq-launcher-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--votiq-launcher-icon-size, 24px);
  height: var(--votiq-launcher-icon-size, 24px);
}
#votiq-widget-root .votiq-launcher-mark svg { width: 100%; height: 100%; display: block; }
#votiq-widget-root .votiq-launcher-mark--sm {
  width: var(--votiq-launcher-icon-size, 22px);
  height: var(--votiq-launcher-icon-size, 22px);
}
#votiq-widget-root .votiq-launcher-img {
  width: var(--votiq-launcher-icon-size, 24px);
  height: var(--votiq-launcher-icon-size, 24px);
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-launcher-img--sm { width: 22px; height: 22px; }
#votiq-widget-root .votiq-launcher--sticky {
  width: auto;
  min-width: 0;
  height: auto;
  min-height: 44px;
  padding: 10px 16px 10px 12px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 28px rgba(0,23,21,0.14);
}
#votiq-widget-root .votiq-launcher--sticky-lime {
  background: #AAF775;
  color: #052D2B;
}
#votiq-widget-root .votiq-launcher--sticky-dark {
  background: #001715;
  color: #AAF775;
}
#votiq-widget-root .votiq-launcher-label {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  white-space: nowrap;
}
#votiq-widget-root .votiq-launcher--sticky-tab {
  width: auto;
  min-width: 42px;
  height: auto;
  min-height: 132px;
  padding: 18px 10px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -4px 0 16px rgba(0, 23, 21, 0.14);
  transition: filter 0.18s ease, transform 0.18s ease;
}
#votiq-widget-root .votiq-launcher--sticky-tab:hover {
  transform: none;
  filter: brightness(1.06);
}
#votiq-widget-root .votiq-launcher--sticky-tab-left {
  box-shadow: 4px 0 16px rgba(0, 23, 21, 0.14);
  border-radius: 0 10px 10px 0;
}
#votiq-widget-root .votiq-launcher--sticky-tab-right {
  border-radius: 10px 0 0 10px;
}
#votiq-widget-root .votiq-launcher--sticky-tab-brand {
  background: #4338ca;
  color: #fff;
}
#votiq-widget-root .votiq-launcher--sticky-tab-dark {
  background: #001715;
  color: #fff;
}
#votiq-widget-root .votiq-launcher-tab-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  line-height: 1;
}
#votiq-widget-root .votiq-launcher--sticky-bar {
  width: auto;
  min-width: 132px;
  height: auto;
  min-height: 42px;
  padding: 10px 18px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -4px 16px rgba(0, 23, 21, 0.14);
  transition: filter 0.18s ease, transform 0.18s ease;
}
#votiq-widget-root .votiq-launcher--sticky-bar:hover {
  transform: none;
  filter: brightness(1.06);
}
#votiq-widget-root .votiq-launcher--sticky-bar-left {
  border-radius: 0 10px 0 0;
}
#votiq-widget-root .votiq-launcher--sticky-bar-right {
  border-radius: 10px 0 0 0;
}
#votiq-widget-root .votiq-launcher-bar-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  white-space: nowrap;
  line-height: 1;
}
#votiq-widget-root .votiq-panel {
  position: relative;
  width: var(--votiq-panel-width);
  min-width: var(--votiq-panel-width);
  max-width: min(var(--votiq-panel-width), calc(100vw - 48px));
  height: var(--votiq-panel-height);
  min-height: var(--votiq-panel-height);
  max-height: var(--votiq-panel-height);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0,23,21,0.16);
}
#votiq-widget-root .votiq-panel > .votiq-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
@keyframes votiq-panel-mount {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
#votiq-widget-root .votiq-panel--mount {
  animation: votiq-panel-mount 0.32s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes votiq-screen-in-forward {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes votiq-screen-in-back {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes votiq-head-in {
  from {
    opacity: 0.55;
  }
  to {
    opacity: 1;
  }
}
#votiq-widget-root .votiq-screen {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}
#votiq-widget-root .votiq-screen--animate.votiq-screen--forward {
  animation: votiq-screen-in-forward 0.28s cubic-bezier(0.22, 1, 0.36, 1) both;
}
#votiq-widget-root .votiq-screen--animate.votiq-screen--back {
  animation: votiq-screen-in-back 0.28s cubic-bezier(0.22, 1, 0.36, 1) both;
}
#votiq-widget-root .votiq-panel-head--animate .votiq-panel-head-title {
  animation: votiq-head-in 0.22s ease-out both;
}
@media (prefers-reduced-motion: reduce) {
  #votiq-widget-root .votiq-panel--mount,
  #votiq-widget-root .votiq-screen--animate.votiq-screen--forward,
  #votiq-widget-root .votiq-screen--animate.votiq-screen--back,
  #votiq-widget-root .votiq-panel-head--animate .votiq-panel-head-title {
    animation: none !important;
  }
}
#votiq-widget-root .votiq-panel > .votiq-panel-nav {
  flex: 0 0 auto;
  margin: 0;
  z-index: 1;
}
#votiq-widget-root .votiq-panel--light { background: #FAFCF9; border: 1px solid #E8ECE9; color: #1A2E2A; }
#votiq-widget-root .votiq-panel--dark { background: #001715; border: 1px solid rgba(255,255,255,0.1); color: #fff; }
#votiq-widget-root .votiq-panel-head {
  position: relative;
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 36px;
  align-items: center;
  gap: 4px;
  min-height: 48px;
  padding: 8px 10px;
  border-bottom: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-head {
  border-bottom: none;
}
#votiq-widget-root .votiq-panel-head-title {
  margin: 0;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: #1A2E2A;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-head-title {
  color: #fff;
}
#votiq-widget-root .votiq-panel-back,
#votiq-widget-root .votiq-panel-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: #0a5c58;
  opacity: 1;
  background: transparent;
}
#votiq-widget-root .votiq-panel-back svg,
#votiq-widget-root .votiq-panel-close svg {
  width: 18px;
  height: 18px;
}
#votiq-widget-root .votiq-panel-close {
  justify-self: end;
}
#votiq-widget-root .votiq-panel-back:hover,
#votiq-widget-root .votiq-panel-close:hover {
  background: rgba(10, 92, 88, 0.08);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-back,
#votiq-widget-root .votiq-panel--dark .votiq-panel-close {
  color: #aaf775;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-back:hover,
#votiq-widget-root .votiq-panel--dark .votiq-panel-close:hover {
  background: rgba(255,255,255,0.08);
}
#votiq-widget-root .votiq-body--hub {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 10px 14px 6px;
  display: flex;
  flex-direction: column;
}
#votiq-widget-root .votiq-body--hub .votiq-screen {
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(26, 46, 42, 0.2) transparent;
}
#votiq-widget-root .votiq-body--hub .votiq-screen::-webkit-scrollbar {
  width: 4px;
}
#votiq-widget-root .votiq-body--hub .votiq-screen::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: rgba(26, 46, 42, 0.18);
}
#votiq-widget-root .votiq-body--scroll {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px 14px 8px;
  display: flex;
  flex-direction: column;
}
#votiq-widget-root .votiq-body--scroll .votiq-screen {
  overflow-x: hidden;
  overflow-y: auto;
}
#votiq-widget-root .votiq-body--form {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
}
#votiq-widget-root .votiq-detail--feedback-form {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#votiq-widget-root .votiq-detail-panel--feedback-form {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#votiq-widget-root .votiq-detail--feedback-form .votiq-field--first {
  margin-top: 0;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-detail--feedback-form .votiq-field--grow {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}
#votiq-widget-root .votiq-detail--feedback-form .votiq-field--grow .votiq-field-textarea {
  flex: 1;
  min-height: 0;
  max-height: none;
  height: auto;
}
#votiq-widget-root .votiq-detail--feedback-form .votiq-attach-row {
  margin-top: 6px;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-detail--feedback-form .votiq-cta--block {
  margin-top: 8px;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-identify {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#votiq-widget-root .votiq-identify-lead {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.45;
  color: #6B7280;
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-lead {
  color: rgba(255, 255, 255, 0.58);
}
#votiq-widget-root .votiq-identify-form {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-identify-error {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  color: #BE123C;
}
#votiq-widget-root .votiq-thanks {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
}
#votiq-widget-root .votiq-thanks-icon {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-thanks-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 999px;
  background: #aaf775;
  color: #0a5c58;
  box-shadow: 0 8px 24px rgba(170, 247, 117, 0.35);
}
#votiq-widget-root .votiq-thanks-icon-badge svg {
  width: 28px;
  height: 28px;
  display: block;
}
#votiq-widget-root .votiq-panel--dark .votiq-thanks-icon-badge {
  background: rgba(170, 247, 117, 0.92);
  color: #052d2b;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
}
#votiq-widget-root .votiq-thanks-lead {
  margin: 0;
  max-width: 280px;
  font-size: 13px;
  line-height: 1.5;
  color: #354140;
  text-align: center;
}
#votiq-widget-root .votiq-thanks .votiq-cta--block {
  width: 100%;
  max-width: 280px;
}
#votiq-widget-root .votiq-panel--dark .votiq-thanks-lead {
  color: rgba(255, 255, 255, 0.82);
}
#votiq-widget-root .votiq-identify-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-identify-divider::before,
#votiq-widget-root .votiq-identify-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(26, 46, 42, 0.1);
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-divider::before,
#votiq-widget-root .votiq-panel--dark .votiq-identify-divider::after {
  background: rgba(255, 255, 255, 0.12);
}
#votiq-widget-root .votiq-identify-divider span {
  font-size: 11px;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: lowercase;
}
#votiq-widget-root .votiq-identify-google {
  width: 100%;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  border: 1px solid rgba(26, 46, 42, 0.1);
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  color: #1A2E2A;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease;
}
#votiq-widget-root .votiq-identify-google:hover {
  background: #FAFCF9;
  border-color: rgba(26, 46, 42, 0.16);
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-google {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.92);
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-google:hover {
  background: rgba(255, 255, 255, 0.12);
}
#votiq-widget-root .votiq-identify-google-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-identify-google-icon .votiq-google-mark {
  width: 18px;
  height: 18px;
  display: block;
}
#votiq-widget-root .votiq-identify-skip {
  margin-top: 10px;
  align-self: center;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #6B7280;
  background: transparent;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-identify-skip:hover {
  color: #1A2E2A;
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-skip {
  color: rgba(255, 255, 255, 0.5);
}
#votiq-widget-root .votiq-panel--dark .votiq-identify-skip:hover {
  color: rgba(255, 255, 255, 0.82);
}
#votiq-widget-root .votiq-hub {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
}
#votiq-widget-root .votiq-hub-primary {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
#votiq-widget-root .votiq-share-card {
  width: 100%;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 20px;
  align-items: center;
  gap: 10px;
  min-height: 64px;
  padding: 12px 12px;
  flex-shrink: 0;
  text-align: left;
  border-radius: 14px;
  border: 1px solid rgba(26, 46, 42, 0.05);
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 23, 21, 0.06);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}
#votiq-widget-root .votiq-share-card:hover {
  border-color: rgba(10, 92, 88, 0.12);
  box-shadow: 0 4px 16px rgba(0, 23, 21, 0.08);
  transform: translateY(-1px);
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card:hover {
  border-color: rgba(170, 247, 117, 0.28);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
}
#votiq-widget-root .votiq-share-card-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  flex-shrink: 0;
  isolation: isolate;
}
#votiq-widget-root .votiq-share-card-icon::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: inherit;
  z-index: -1;
  opacity: 0.32;
  filter: blur(4px);
}
#votiq-widget-root .votiq-share-card-icon .votiq-feature-svg {
  width: 20px;
  height: 20px;
  display: block;
}
#votiq-widget-root .votiq-share-card-icon--feature {
  color: #1A2E2A;
  background: #E4F7C8;
  box-shadow: 0 1px 3px rgba(170, 247, 117, 0.12);
}
#votiq-widget-root .votiq-share-card-icon--feature::after {
  background: #aaf775;
}
#votiq-widget-root .votiq-share-card-icon--bug {
  color: #9B1C31;
  background: #FFDAD6;
  box-shadow: 0 1px 3px rgba(255, 154, 144, 0.14);
}
#votiq-widget-root .votiq-share-card-icon--bug::after {
  background: #ff9a90;
}
#votiq-widget-root .votiq-share-card-icon--general {
  color: #0d5c56;
  background: #C4EAE6;
  box-shadow: 0 1px 3px rgba(90, 180, 168, 0.12);
}
#votiq-widget-root .votiq-share-card-icon--general::after {
  background: #7dd3c0;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--feature {
  color: #f0fde4;
  background: rgba(170, 247, 117, 0.35);
  box-shadow: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--feature::after {
  background: rgba(170, 247, 117, 0.4);
  opacity: 0.25;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--bug {
  color: #fecdd3;
  background: rgba(255, 218, 214, 0.35);
  box-shadow: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--bug::after {
  background: rgba(255, 154, 144, 0.45);
  opacity: 0.25;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--general {
  color: #ccfbf1;
  background: rgba(196, 234, 230, 0.35);
  box-shadow: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-icon--general::after {
  background: rgba(125, 211, 192, 0.45);
  opacity: 0.25;
}
#votiq-widget-root .votiq-share-card-title {
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: #1A2E2A;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card-title {
  color: rgba(255, 255, 255, 0.95);
}
#votiq-widget-root .votiq-share-card-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}
#votiq-widget-root .votiq-share-card-chevron svg {
  width: 16px;
  height: 16px;
}
#votiq-widget-root .votiq-share-card:hover .votiq-share-card-chevron {
  color: #0a5c58;
}
#votiq-widget-root .votiq-panel--dark .votiq-share-card:hover .votiq-share-card-chevron {
  color: #aaf775;
}
#votiq-widget-root .votiq-hub-secondary {
  display: grid;
  gap: 6px;
  margin-top: 2px;
}
#votiq-widget-root .votiq-hub-secondary--count-1 {
  grid-template-columns: 1fr;
}
#votiq-widget-root .votiq-hub-secondary--count-2 {
  grid-template-columns: repeat(2, 1fr);
}
#votiq-widget-root .votiq-hub-secondary--count-3 {
  grid-template-columns: repeat(3, 1fr);
}
#votiq-widget-root .votiq-hub-mini-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 50px;
  padding: 7px 4px;
  border-radius: 10px;
  border: 1px solid #e8eef8;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.04);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  box-shadow: none;
}
#votiq-widget-root .votiq-hub-mini-btn:hover {
  border-color: rgba(170, 247, 117, 0.45);
  background: #fcfff9;
  box-shadow: 0 2px 6px rgba(0, 23, 21, 0.05);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn:hover {
  border-color: rgba(170, 247, 117, 0.3);
  background: rgba(170, 247, 117, 0.06);
}
#votiq-widget-root .votiq-hub-mini-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
#votiq-widget-root .votiq-hub-mini-btn-icon svg {
  width: 16px;
  height: 16px;
  display: block;
}
#votiq-widget-root .votiq-hub-mini-btn-icon--roadmap {
  color: #5b5fc9;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn-icon--roadmap {
  color: #a5b4fc;
}
#votiq-widget-root .votiq-hub-mini-btn-icon--changelog {
  color: #d97706;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn-icon--changelog {
  color: #fdba74;
}
#votiq-widget-root .votiq-hub-mini-btn-icon--docs {
  color: #0e7c9e;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn-icon--docs {
  color: #67d4f0;
}
#votiq-widget-root .votiq-hub-mini-btn-text {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.1;
  color: #414847;
  text-align: center;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-mini-btn-text {
  color: rgba(255, 255, 255, 0.78);
}
#votiq-widget-root .votiq-hub-actions {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
}
#votiq-widget-root .votiq-hub-btn {
  position: relative;
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  border: 1px solid #EFF4FF;
  background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 1px 2px rgba(0, 23, 21, 0.05),
    0 4px 12px rgba(0, 23, 21, 0.03);
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;
}
#votiq-widget-root .votiq-hub-btn--featured {
  height: 56px;
  min-height: 56px;
  border-radius: 14px;
  padding: 0 12px 0 14px;
  overflow: hidden;
}
#votiq-widget-root .votiq-hub-btn--featured::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(180deg, #aaf775 0%, #0a5c58 100%);
}
#votiq-widget-root .votiq-hub-btn--trail {
  height: 48px;
  min-height: 48px;
  border-radius: 12px;
  padding: 0 10px;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) 36px;
  align-items: center;
  column-gap: 10px;
  gap: 0;
}
#votiq-widget-root .votiq-hub-btn--compact {
  height: 40px;
  min-height: 40px;
  border-radius: 999px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  background: linear-gradient(90deg, #fff7ed 0%, #ffffff 62%);
  border-color: #ffedd5;
}
#votiq-widget-root .votiq-hub-btn--tile {
  height: 48px;
  min-height: 48px;
  gap: 0;
  padding: 0;
  padding-right: 10px;
  border-radius: 12px;
  overflow: hidden;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn {
  border-color: rgba(255, 255, 255, 0.1);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.03) 100%
  );
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.06) inset,
    0 4px 14px rgba(0, 0, 0, 0.22);
}
#votiq-widget-root .votiq-hub-btn:hover {
  border-color: rgba(170, 247, 117, 0.55);
  background: linear-gradient(180deg, #ffffff 0%, #f4fbeb 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 0 0 1px rgba(170, 247, 117, 0.22),
    0 6px 18px rgba(170, 247, 117, 0.16);
  transform: translateY(-1px);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn:hover {
  border-color: rgba(170, 247, 117, 0.45);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.11) 0%,
    rgba(170, 247, 117, 0.08) 100%
  );
}
#votiq-widget-root .votiq-hub-btn:active {
  transform: translateY(0);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9) inset,
    0 1px 3px rgba(0, 23, 21, 0.08);
}
#votiq-widget-root .votiq-hub-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.06);
  overflow: hidden;
}
#votiq-widget-root .votiq-hub-btn-icon svg {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-hub-btn-icon--feedback {
  color: #0a5c58;
  background: linear-gradient(145deg, #d8f9b8 0%, #aaf775 100%);
}
#votiq-widget-root .votiq-hub-btn-icon--roadmap {
  color: #4338ca;
  background: linear-gradient(145deg, #eef2ff 0%, #e0e7ff 100%);
}
#votiq-widget-root .votiq-hub-btn-icon--changelog {
  color: #b45309;
  background: linear-gradient(145deg, #fff7ed 0%, #ffedd5 100%);
}
#votiq-widget-root .votiq-hub-btn-icon--docs {
  color: #0369a1;
  background: linear-gradient(145deg, #f0f9ff 0%, #e0f2fe 100%);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-icon {
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-icon--feedback {
  color: #d8f9b8;
  background: linear-gradient(145deg, rgba(170, 247, 117, 0.35) 0%, rgba(10, 92, 88, 0.55) 100%);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-icon--roadmap {
  color: #c7d2fe;
  background: linear-gradient(145deg, rgba(99, 102, 241, 0.35) 0%, rgba(67, 56, 202, 0.45) 100%);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-icon--changelog {
  color: #fed7aa;
  background: linear-gradient(145deg, rgba(251, 146, 60, 0.35) 0%, rgba(180, 83, 9, 0.45) 100%);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-icon--docs {
  color: #bae6fd;
  background: linear-gradient(145deg, rgba(56, 189, 248, 0.3) 0%, rgba(3, 105, 161, 0.45) 100%);
}
#votiq-widget-root .votiq-hub-btn-copy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1px;
}
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-chevron {
  grid-column: 1;
  justify-self: center;
  align-self: center;
  width: 18px;
  height: 18px;
}
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-copy {
  grid-column: 2;
  align-items: flex-end;
  justify-content: center;
  text-align: right;
  padding-right: 2px;
}
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-kicker,
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-text {
  width: 100%;
  text-align: right;
}
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-icon {
  grid-column: 3;
  justify-self: end;
  align-self: center;
  width: 36px;
  height: 36px;
}
#votiq-widget-root .votiq-hub-btn--tile .votiq-hub-btn-copy {
  padding: 0 8px;
}
#votiq-widget-root .votiq-hub-btn-kicker {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.01em;
  color: #6b7280;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-kicker {
  color: rgba(255, 255, 255, 0.5);
}
#votiq-widget-root .votiq-hub-btn-text {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #001715;
}
#votiq-widget-root .votiq-hub-btn-compact-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  flex: 0 0 auto;
}
#votiq-widget-root .votiq-hub-btn--compact .votiq-hub-btn-icon {
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
  border-radius: 8px;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-hub-btn--compact .votiq-hub-btn-icon svg {
  width: 15px;
  height: 15px;
}
#votiq-widget-root .votiq-hub-btn--compact .votiq-hub-btn-text {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
#votiq-widget-root .votiq-hub-btn-tile-side {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 100%;
  flex-shrink: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
#votiq-widget-root .votiq-hub-btn-tile-side svg {
  width: 20px;
  height: 20px;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn--compact {
  background: linear-gradient(90deg, rgba(251, 146, 60, 0.15) 0%, rgba(255, 255, 255, 0.05) 55%);
  border-color: rgba(251, 146, 60, 0.25);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-text {
  color: rgba(255, 255, 255, 0.92);
}
#votiq-widget-root .votiq-hub-btn-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #94a3b8;
  opacity: 0.85;
  transition: color 0.18s ease, transform 0.18s ease, opacity 0.18s ease;
}
#votiq-widget-root .votiq-hub-btn-chevron svg {
  width: 16px;
  height: 16px;
  display: block;
}
#votiq-widget-root .votiq-hub-btn:hover .votiq-hub-btn-chevron {
  color: #0a5c58;
  opacity: 1;
  transform: translateX(1px);
}
#votiq-widget-root .votiq-hub-btn--trail:hover .votiq-hub-btn-chevron {
  transform: translateX(-2px);
}
#votiq-widget-root .votiq-hub-btn--trail .votiq-hub-btn-chevron svg {
  width: 14px;
  height: 14px;
}
#votiq-widget-root .votiq-hub-btn--compact .votiq-hub-btn-chevron {
  display: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn-chevron {
  color: rgba(255, 255, 255, 0.4);
}
#votiq-widget-root .votiq-panel--dark .votiq-hub-btn:hover .votiq-hub-btn-chevron {
  color: #aaf775;
}
#votiq-widget-root .votiq-hero {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-bottom: 1px solid #EFF4FF;
}
#votiq-widget-root .votiq-panel--dark .votiq-hero { border-color: rgba(255,255,255,0.1); }
#votiq-widget-root .votiq-hero-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 120% 80% at 100% 0%, rgba(170,247,117,0.35) 0%, transparent 55%),
    linear-gradient(165deg, #F8F9FF 0%, #EFF4FF 48%, #fff 100%);
  pointer-events: none;
}
#votiq-widget-root .votiq-panel--dark .votiq-hero-bg {
  background:
    radial-gradient(ellipse 100% 70% at 100% 0%, rgba(170,247,117,0.18) 0%, transparent 50%),
    linear-gradient(165deg, #001715 0%, #052D2B 55%, #001715 100%);
}
#votiq-widget-root .votiq-hero-inner {
  position: relative;
  padding: 14px 44px 12px 14px;
}
#votiq-widget-root .votiq-hero-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0;
}
#votiq-widget-root .votiq-hero-logo {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  filter: drop-shadow(0 4px 10px rgba(170,247,117,0.35));
}
#votiq-widget-root .votiq-hero-logo svg {
  display: block;
  width: 100%;
  height: 100%;
}
#votiq-widget-root .votiq-hero-wordmark {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  color: #001715;
}
#votiq-widget-root .votiq-panel--dark .votiq-hero-wordmark { color: #fff; }
#votiq-widget-root .votiq-header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
}
#votiq-widget-root .votiq-header-msg {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #414847;
  opacity: 1;
}
#votiq-widget-root .votiq-panel--dark .votiq-header-msg { color: rgba(255,255,255,0.72); }
#votiq-widget-root .votiq-close {
  padding: 6px;
  border-radius: 8px;
  opacity: 0.55;
  flex-shrink: 0;
  color: inherit;
}
#votiq-widget-root .votiq-hero-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background: rgba(255,255,255,0.75);
  backdrop-filter: blur(4px);
}
#votiq-widget-root .votiq-panel--dark .votiq-hero-close {
  background: rgba(0,23,21,0.45);
  color: rgba(255,255,255,0.85);
}
#votiq-widget-root .votiq-close:hover { opacity: 1; background: #EFF4FF; }
#votiq-widget-root .votiq-panel--dark .votiq-close:hover { background: rgba(255,255,255,0.12); }
#votiq-widget-root .votiq-tabs { display: flex; gap: 4px; padding: 6px 8px; border-bottom: 1px solid #EFF4FF; background: rgba(248,249,255,0.8); flex-shrink: 0; }
#votiq-widget-root .votiq-panel--dark .votiq-tabs { border-color: rgba(255,255,255,0.1); background: rgba(255,255,255,0.05); }
#votiq-widget-root .votiq-tab {
  flex: 1; padding: 6px 8px; border-radius: 8px; font-size: 11px; font-weight: 500;
  display: flex; align-items: center; justify-content: center; gap: 4px; opacity: 0.65;
}
#votiq-widget-root .votiq-tab--active { opacity: 1; background: #fff; box-shadow: 0 1px 2px rgba(0,0,0,0.06); font-weight: 600; color: #052D2B; }
#votiq-widget-root .votiq-panel--dark .votiq-tab--active { background: rgba(255,255,255,0.15); color: #fff; box-shadow: none; }
#votiq-widget-root .votiq-panel-nav {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 8px 10px 10px;
  border-top: 1px solid rgba(26, 46, 42, 0.06);
  background: #F5F7F3;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav {
  background: rgba(255, 255, 255, 0.04);
}
#votiq-widget-root .votiq-panel-nav-list {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: transparent;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-list {
  background: transparent;
}
#votiq-widget-root .votiq-panel-nav-btn {
  flex: 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 8px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #5c6b66;
  background: transparent;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
#votiq-widget-root .votiq-panel-nav-btn--docs {
  background: #E8EDE9;
  color: #4a5c56;
}
#votiq-widget-root .votiq-panel-nav-btn--roadmap {
  background: #C1E7E3;
  color: #0a5c58;
}
#votiq-widget-root .votiq-panel-nav-btn--changelog {
  background: #EDE6DC;
  color: #5c564e;
}
#votiq-widget-root .votiq-panel-nav-btn:hover {
  box-shadow: 0 1px 3px rgba(0, 23, 21, 0.06);
}
#votiq-widget-root .votiq-panel-nav-btn--docs:hover {
  background: #dfe8e3;
  color: #1A2E2A;
}
#votiq-widget-root .votiq-panel-nav-btn--roadmap:hover {
  background: #b3ddd8;
  color: #084a47;
}
#votiq-widget-root .votiq-panel-nav-btn--changelog:hover {
  background: #e3dbd0;
  color: #1A2E2A;
}
#votiq-widget-root .votiq-panel-nav-btn--active {
  box-shadow: 0 1px 3px rgba(0, 23, 21, 0.07);
}
#votiq-widget-root .votiq-panel-nav-btn--active.votiq-panel-nav-btn--docs {
  background: #dfe8e3;
  color: #0a5c58;
}
#votiq-widget-root .votiq-panel-nav-btn--active.votiq-panel-nav-btn--roadmap {
  background: #C1E7E3;
  color: #084a47;
}
#votiq-widget-root .votiq-panel-nav-btn--active.votiq-panel-nav-btn--changelog {
  background: #e3dbd0;
  color: #0a5c58;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn {
  color: rgba(255, 255, 255, 0.55);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn--docs {
  background: rgba(232, 237, 233, 0.12);
  color: rgba(255, 255, 255, 0.72);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn--roadmap {
  background: rgba(193, 231, 227, 0.22);
  color: #aaf775;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn--changelog {
  background: rgba(237, 230, 220, 0.14);
  color: rgba(255, 255, 255, 0.72);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn:hover {
  color: rgba(255, 255, 255, 0.9);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-nav-btn--active {
  color: #aaf775;
  box-shadow: none;
}
#votiq-widget-root .votiq-panel-nav-btn-icon {
  display: inline-flex;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  color: inherit;
}
#votiq-widget-root .votiq-panel-nav-btn-icon svg {
  width: 15px;
  height: 15px;
  display: block;
}
#votiq-widget-root .votiq-panel-nav-btn-label {
  white-space: nowrap;
}
#votiq-widget-root .votiq-panel-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-decoration: none;
  color: #9CA3AF;
  font-size: 10px;
  font-weight: 500;
  transition: color 0.15s ease;
}
#votiq-widget-root .votiq-panel-brand:hover {
  color: #6B7280;
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-brand {
  color: rgba(255, 255, 255, 0.38);
}
#votiq-widget-root .votiq-panel--dark .votiq-panel-brand:hover {
  color: rgba(255, 255, 255, 0.58);
}
#votiq-widget-root .votiq-panel-brand-logo {
  display: inline-flex;
  width: 12px;
  height: 12px;
}
#votiq-widget-root .votiq-panel-brand-logo svg {
  width: 100%;
  height: 100%;
  display: block;
}
#votiq-widget-root .votiq-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}
#votiq-widget-root .votiq-list-toolbar-label {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.55;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
#votiq-widget-root .votiq-feature-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
#votiq-widget-root .votiq-feature-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11px;
  border-radius: 12px;
  padding: 11px 11px;
  text-align: left;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fff 0%, #fafbff 100%);
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.04);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn {
  border-color: rgba(255,255,255,0.1);
  background: linear-gradient(180deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.03) 100%);
  box-shadow: 0 1px 0 rgba(255,255,255,0.06) inset, 0 1px 2px rgba(0,0,0,0.2);
}
#votiq-widget-root .votiq-feature-btn:hover {
  border-color: rgba(170, 247, 117, 0.45);
  background: #fcfff8;
  box-shadow: 0 2px 8px rgba(0, 23, 21, 0.06);
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn:hover {
  border-color: rgba(170, 247, 117, 0.32);
  background: rgba(170, 247, 117, 0.06);
  box-shadow: none;
}
#votiq-widget-root .votiq-feature-btn:active {
  transform: translateY(0.5px);
}
#votiq-widget-root .votiq-feature-btn-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border-radius: 8px;
  border: none;
  box-shadow: none;
}
#votiq-widget-root .votiq-feature-btn-icon--feature {
  color: #3d6b52;
  background: #f0f6ec;
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn-icon--feature {
  color: #b8ddb0;
  background: rgba(170, 247, 117, 0.12);
}
#votiq-widget-root .votiq-feature-btn-icon--bug {
  color: #8b4a55;
  background: #f6f0f1;
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn-icon--bug {
  color: #e8c4ca;
  background: rgba(244, 63, 94, 0.12);
}
#votiq-widget-root .votiq-feature-btn-icon--improve {
  color: #4a6278;
  background: #eef2f6;
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn-icon--improve {
  color: #b8c9d9;
  background: rgba(255, 255, 255, 0.08);
}
#votiq-widget-root .votiq-feature-btn-icon .votiq-feature-svg {
  width: 17px;
  height: 17px;
  display: block;
  opacity: 0.92;
}
#votiq-widget-root .votiq-feature-btn-text {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.3;
  color: #052d2b;
}
#votiq-widget-root .votiq-panel--dark .votiq-feature-btn-text {
  color: rgba(255, 255, 255, 0.92);
}
#votiq-widget-root .votiq-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: auto;
  height: 32px;
  padding: 0 12px;
  border-radius: 10px;
  background: #AAF775;
  color: #052D2B;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  flex-shrink: 0;
}
#votiq-widget-root .votiq-cta svg { width: 14px; height: 14px; }
#votiq-widget-root .votiq-cta--block { width: 100%; height: 34px; margin-top: 12px; flex-shrink: 0; }
#votiq-widget-root .votiq-card {
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 6px;
  display: flex;
  gap: 10px;
  width: 100%;
  text-align: left;
}
#votiq-widget-root .votiq-card--clickable {
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
#votiq-widget-root .votiq-panel--light .votiq-card--clickable:hover {
  border-color: rgba(170,247,117,0.5);
  box-shadow: 0 2px 8px rgba(0,23,21,0.06);
}
#votiq-widget-root .votiq-card-content { flex: 1; min-width: 0; display: flex; flex-direction: column; }
#votiq-widget-root .votiq-card-title {
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin: 2px 0 0;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#votiq-widget-root .votiq-card-meta { display: block; }
#votiq-widget-root .votiq-card--roadmap {
  justify-content: space-between;
  align-items: center;
}
#votiq-widget-root .votiq-card-roadmap-main { display: flex; flex-direction: column; gap: 4px; min-width: 0; flex: 1; }
#votiq-widget-root .votiq-card-votes { font-size: 12px; font-weight: 700; flex-shrink: 0; }
#votiq-widget-root .votiq-back-bar { margin-bottom: 12px; }
#votiq-widget-root .votiq-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.7;
  padding: 4px 0;
}
#votiq-widget-root .votiq-back:hover { opacity: 1; }
#votiq-widget-root .votiq-back svg { width: 16px; height: 16px; }
#votiq-widget-root .votiq-detail-title {
  margin: 6px 0 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}
#votiq-widget-root .votiq-detail-desc {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  opacity: 0.72;
}
#votiq-widget-root .votiq-detail-vote {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
}
#votiq-widget-root .votiq-panel--light .votiq-detail-vote {
  border: 1px solid #EFF4FF;
  background: #F8F9FF;
}
#votiq-widget-root .votiq-field { display: block; margin-top: 12px; }
#votiq-widget-root .votiq-field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.65;
}
#votiq-widget-root .votiq-field-input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #EFF4FF;
  padding: 8px 10px;
  font-size: 13px;
  font-family: inherit;
  background: #fff;
  color: inherit;
}
#votiq-widget-root .votiq-panel--dark .votiq-field-input {
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.12);
}
#votiq-widget-root .votiq-field-textarea { resize: none; min-height: 56px; }
#votiq-widget-root .votiq-detail--feedback-form .votiq-field-textarea {
  resize: none;
  min-height: 44px;
  overflow: hidden;
}
#votiq-widget-root .votiq-attach-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
#votiq-widget-root .votiq-attach-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
#votiq-widget-root .votiq-attach-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
  border: 1px dashed rgba(0, 23, 21, 0.2);
  background: transparent;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
#votiq-widget-root .votiq-attach-btn svg {
  width: 16px;
  height: 16px;
  opacity: 0.75;
}
#votiq-widget-root .votiq-attach-btn:hover {
  border-color: rgba(170, 247, 117, 0.8);
  background: rgba(170, 247, 117, 0.12);
}
#votiq-widget-root .votiq-attach-btn:hover svg { opacity: 1; }
#votiq-widget-root .votiq-panel--dark .votiq-attach-btn {
  border-color: rgba(255, 255, 255, 0.2);
}
#votiq-widget-root .votiq-panel--dark .votiq-attach-btn:hover {
  border-color: rgba(170, 247, 117, 0.5);
  background: rgba(170, 247, 117, 0.1);
}
#votiq-widget-root .votiq-attach-count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  background: #AAF775;
  color: #052D2B;
}
#votiq-widget-root .votiq-panel--light .votiq-card { background: #fff; border: 1px solid #EFF4FF; box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
#votiq-widget-root .votiq-panel--dark .votiq-card { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); }
#votiq-widget-root .votiq-roadmap-screen { margin: 0; }
#votiq-widget-root .votiq-roadmap-head,
#votiq-widget-root .votiq-roadmap-list-head {
  margin-bottom: 8px;
}
#votiq-widget-root .votiq-roadmap-list-head {
  margin-top: 4px;
}
#votiq-widget-root .votiq-roadmap-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-bottom: 14px;
}
#votiq-widget-root .votiq-stat {
  border-radius: 11px;
  padding: 10px 6px;
  text-align: center;
  border: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.7);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
#votiq-widget-root .votiq-panel--dark .votiq-stat {
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);
}
#votiq-widget-root .votiq-stat--planned {
  background: linear-gradient(180deg, #eef2ff 0%, #e0e7ff 100%);
  border-color: rgba(99, 102, 241, 0.22);
  color: #1e293b;
}
#votiq-widget-root .votiq-panel--dark .votiq-stat--planned {
  background: linear-gradient(180deg, rgba(49, 46, 129, 0.5) 0%, rgba(30, 27, 75, 0.4) 100%);
  border-color: rgba(129, 140, 248, 0.35);
  color: #e0e7ff;
}
#votiq-widget-root .votiq-stat--progress {
  background: linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%);
  border-color: rgba(245, 158, 11, 0.28);
  color: #78350f;
}
#votiq-widget-root .votiq-panel--dark .votiq-stat--progress {
  background: linear-gradient(180deg, rgba(120, 53, 15, 0.5) 0%, rgba(69, 26, 3, 0.38) 100%);
  border-color: rgba(251, 191, 36, 0.35);
  color: #fde68a;
}
#votiq-widget-root .votiq-stat--shipped {
  background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: rgba(16, 185, 129, 0.28);
  color: #064e3b;
}
#votiq-widget-root .votiq-panel--dark .votiq-stat--shipped {
  background: linear-gradient(180deg, rgba(6, 78, 59, 0.55) 0%, rgba(4, 47, 46, 0.4) 100%);
  border-color: rgba(52, 211, 153, 0.38);
  color: #a7f3d0;
}
#votiq-widget-root .votiq-stat-label {
  font-size: 9.5px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.07em;
  opacity: 0.58;
}
#votiq-widget-root .votiq-stat-value {
  font-size: 20px;
  font-weight: 800;
  margin-top: 4px;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.03em;
  line-height: 1.1;
}
#votiq-widget-root .votiq-badge {
  display: inline-flex;
  align-items: center;
  font-size: 9.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 3px 7px;
  border-radius: 7px;
  margin: 0 0 2px 0;
  border: 1px solid transparent;
  width: fit-content;
}
#votiq-widget-root .votiq-badge--planned {
  background: linear-gradient(180deg, #eef2ff 0%, #e0e7ff 100%);
  color: #312e81;
  border-color: rgba(99, 102, 241, 0.25);
}
#votiq-widget-root .votiq-panel--dark .votiq-badge--planned {
  background: linear-gradient(180deg, rgba(55, 48, 163, 0.65) 0%, rgba(30, 27, 75, 0.85) 100%);
  color: #e0e7ff;
  border-color: rgba(129, 140, 248, 0.35);
}
#votiq-widget-root .votiq-badge--progress {
  background: linear-gradient(180deg, #fffbeb 0%, #fde68a 100%);
  color: #92400e;
  border-color: rgba(245, 158, 11, 0.35);
}
#votiq-widget-root .votiq-panel--dark .votiq-badge--progress {
  background: linear-gradient(180deg, rgba(146, 64, 14, 0.55) 0%, rgba(120, 53, 15, 0.65) 100%);
  color: #fef3c7;
  border-color: rgba(251, 191, 36, 0.4);
}
#votiq-widget-root .votiq-badge--shipped {
  background: linear-gradient(180deg, #052D2B 0%, #001715 100%);
  color: #ecfdf5;
  border-color: rgba(170, 247, 117, 0.35);
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.2);
}
#votiq-widget-root .votiq-panel--dark .votiq-badge--shipped {
  background: linear-gradient(180deg, #AAF775 0%, #86efac 100%);
  color: #052D2B;
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: none;
}
#votiq-widget-root .votiq-roadmap-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-align: left;
  border-radius: 12px;
  padding: 11px 11px;
  margin-bottom: 6px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fff 0%, #fafbff 100%);
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.04);
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
#votiq-widget-root .votiq-panel--dark .votiq-roadmap-item {
  border-color: rgba(255,255,255,0.1);
  background: linear-gradient(180deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.03) 100%);
  box-shadow: 0 1px 0 rgba(255,255,255,0.06) inset, 0 1px 2px rgba(0,0,0,0.2);
}
#votiq-widget-root .votiq-roadmap-item:hover {
  border-color: rgba(170, 247, 117, 0.45);
  box-shadow: 0 2px 12px rgba(0, 23, 21, 0.08), 0 0 0 1px rgba(170, 247, 117, 0.12);
}
#votiq-widget-root .votiq-panel--dark .votiq-roadmap-item:hover {
  border-color: rgba(170, 247, 117, 0.3);
  box-shadow: 0 4px 16px rgba(0,0,0,0.35), 0 0 0 1px rgba(170, 247, 117, 0.1);
}
#votiq-widget-root .votiq-roadmap-item-main {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  flex: 1;
}
#votiq-widget-root .votiq-roadmap-item-title {
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
#votiq-widget-root .votiq-roadmap-votes-pill {
  flex-shrink: 0;
}
#votiq-widget-root .votiq-roadmap-votes-pill-inner {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 5px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  background: rgba(170, 247, 117, 0.18);
  color: #065f46;
  border: 1px solid rgba(170, 247, 117, 0.45);
}
#votiq-widget-root .votiq-panel--dark .votiq-roadmap-votes-pill-inner {
  background: rgba(170, 247, 117, 0.12);
  color: #bbf7d0;
  border-color: rgba(170, 247, 117, 0.25);
}
#votiq-widget-root .votiq-roadmap-votes-pill-inner svg {
  width: 11px;
  height: 11px;
  opacity: 0.85;
}
#votiq-widget-root .votiq-detail-kicker {
  margin: 6px 0 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.45;
  opacity: 0.55;
  letter-spacing: 0.01em;
}
#votiq-widget-root .votiq-detail-panel--roadmap .votiq-detail-title {
  margin-top: 8px;
}
#votiq-widget-root .votiq-detail-panel--roadmap .votiq-detail-desc {
  margin-top: 10px;
}
#votiq-widget-root .votiq-vote {
  display: flex; flex-direction: column; align-items: center; padding: 6px 8px;
  border-radius: 8px; min-width: 40px; font-size: 12px; font-weight: 700;
}
#votiq-widget-root .votiq-panel--light .votiq-vote { border: 1px solid #EFF4FF; background: #F8F9FF; color: #414847; }
#votiq-widget-root .votiq-vote--active { border-color: rgba(170,247,117,0.6); background: rgba(170,247,117,0.2); color: #357200; }
#votiq-widget-root .votiq-card-meta { font-size: 10px; text-transform: uppercase; font-weight: 600; opacity: 0.5; letter-spacing: 0.04em; }
#votiq-widget-root .votiq-updates-screen { margin: 0; }
#votiq-widget-root .votiq-updates-head { margin-bottom: 10px; }
#votiq-widget-root .votiq-release-card {
  border-radius: 14px;
  padding: 12px 12px 10px;
  margin-bottom: 10px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fff 0%, #fafbff 100%);
  box-shadow: 0 1px 2px rgba(0, 23, 21, 0.04), inset 0 1px 0 rgba(255,255,255,0.9);
}
#votiq-widget-root .votiq-panel--dark .votiq-release-card {
  border-color: rgba(255,255,255,0.1);
  background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
  box-shadow: 0 1px 0 rgba(255,255,255,0.06) inset, 0 2px 8px rgba(0,0,0,0.15);
}
#votiq-widget-root .votiq-release-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}
#votiq-widget-root .votiq-release-version-pill {
  display: inline-flex;
  align-items: center;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: -0.02em;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(170, 247, 117, 0.45);
  background: linear-gradient(180deg, rgba(170, 247, 117, 0.22) 0%, rgba(170, 247, 117, 0.1) 100%);
  color: #052D2B;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.45);
}
#votiq-widget-root .votiq-panel--dark .votiq-release-version-pill {
  color: #ecfdf5;
  border-color: rgba(170, 247, 117, 0.35);
  background: linear-gradient(180deg, rgba(170, 247, 117, 0.2) 0%, rgba(5, 45, 43, 0.6) 100%);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);
}
#votiq-widget-root .votiq-release-date {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.48;
}
#votiq-widget-root .votiq-release-card-title {
  margin: 8px 0 0;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.015em;
  line-height: 1.35;
  opacity: 0.88;
}
#votiq-widget-root .votiq-changelog-items {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
}
#votiq-widget-root .votiq-changelog-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 7px 0;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}
#votiq-widget-root .votiq-changelog-item:first-child { border-top: none; padding-top: 0; }
#votiq-widget-root .votiq-panel--dark .votiq-changelog-item {
  border-color: rgba(255,255,255,0.08);
}
#votiq-widget-root .votiq-entry-pill {
  flex-shrink: 0;
  margin-top: 1px;
  display: inline-flex;
  align-items: center;
  font-size: 8.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  line-height: 1;
}
#votiq-widget-root .votiq-entry-pill--new {
  background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);
  color: #065f46;
  border-color: rgba(16, 185, 129, 0.35);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--new {
  background: linear-gradient(180deg, rgba(6, 78, 59, 0.55) 0%, rgba(4, 47, 46, 0.45) 100%);
  color: #a7f3d0;
  border-color: rgba(52, 211, 153, 0.35);
}
#votiq-widget-root .votiq-entry-pill--improved {
  background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%);
  color: #1d4ed8;
  border-color: rgba(59, 130, 246, 0.35);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--improved {
  background: linear-gradient(180deg, rgba(30, 58, 138, 0.45) 0%, rgba(23, 37, 84, 0.4) 100%);
  color: #bfdbfe;
  border-color: rgba(96, 165, 250, 0.35);
}
#votiq-widget-root .votiq-entry-pill--deprecated {
  background: linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%);
  color: #b45309;
  border-color: rgba(245, 158, 11, 0.4);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--deprecated {
  background: linear-gradient(180deg, rgba(120, 53, 15, 0.5) 0%, rgba(69, 26, 3, 0.42) 100%);
  color: #fde68a;
  border-color: rgba(251, 191, 36, 0.4);
}
#votiq-widget-root .votiq-entry-pill--removed {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  color: #475569;
  border-color: rgba(100, 116, 139, 0.35);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--removed {
  background: linear-gradient(180deg, rgba(51, 65, 85, 0.5) 0%, rgba(30, 41, 59, 0.45) 100%);
  color: #cbd5e1;
  border-color: rgba(148, 163, 184, 0.35);
}
#votiq-widget-root .votiq-entry-pill--fixed {
  background: linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%);
  color: #be123c;
  border-color: rgba(244, 63, 94, 0.35);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--fixed {
  background: linear-gradient(180deg, rgba(136, 19, 55, 0.45) 0%, rgba(76, 5, 25, 0.4) 100%);
  color: #fda4af;
  border-color: rgba(251, 113, 133, 0.35);
}
#votiq-widget-root .votiq-entry-pill--security {
  background: linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%);
  color: #b45309;
  border-color: rgba(245, 158, 11, 0.4);
}
#votiq-widget-root .votiq-panel--dark .votiq-entry-pill--security {
  background: linear-gradient(180deg, rgba(120, 53, 15, 0.5) 0%, rgba(69, 26, 3, 0.42) 100%);
  color: #fde68a;
  border-color: rgba(251, 191, 36, 0.4);
}
#votiq-widget-root .votiq-changelog-item-title {
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
}
#votiq-widget-root .votiq-hidden { display: none !important; }
#votiq-widget-root.votiq-root--preview {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
#votiq-widget-root.votiq-root--preview .votiq-stack {
  position: absolute;
  pointer-events: none;
  --votiq-preview-inset: 24px;
  width: max-content;
  height: auto;
  max-width: calc(var(--votiq-preview-w, 100%) - (var(--votiq-preview-inset) * 2));
  max-height: none;
  overflow: visible;
}
#votiq-widget-root.votiq-root--preview .votiq-stack > * {
  pointer-events: auto;
}
#votiq-widget-root.votiq-root--preview .votiq-stack--bottom-right {
  top: auto;
  left: auto;
  right: var(--votiq-preview-inset);
  bottom: var(--votiq-preview-inset);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--bottom-left {
  top: auto;
  right: auto;
  left: var(--votiq-preview-inset);
  bottom: var(--votiq-preview-inset);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--top-right {
  bottom: auto;
  left: auto;
  top: var(--votiq-preview-inset);
  right: var(--votiq-preview-inset);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--top-left {
  bottom: auto;
  right: auto;
  top: var(--votiq-preview-inset);
  left: var(--votiq-preview-inset);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--left-middle {
  left: 0;
  right: auto;
  top: 50%;
  bottom: auto;
  transform: translateY(-50%);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--right-middle {
  right: 0;
  left: auto;
  top: 50%;
  bottom: auto;
  transform: translateY(-50%);
}
#votiq-widget-root.votiq-root--preview .votiq-stack--left-bottom {
  left: 0;
  right: auto;
  bottom: 0;
  top: auto;
  transform: none;
}
#votiq-widget-root.votiq-root--preview .votiq-stack--right-bottom {
  right: 0;
  left: auto;
  bottom: 0;
  top: auto;
  transform: none;
}
#votiq-widget-root.votiq-root--preview .votiq-panel {
  width: var(--votiq-panel-width) !important;
  min-width: var(--votiq-panel-width) !important;
  max-width: var(--votiq-panel-width) !important;
  height: var(--votiq-panel-height) !important;
  min-height: var(--votiq-panel-height) !important;
  max-height: var(--votiq-panel-height) !important;
  flex: 0 0 auto !important;
  overflow: hidden;
}
#votiq-widget-root.votiq-root--preview .votiq-launcher {
  flex-shrink: 0;
}
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack {
  left: 50% !important;
  top: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
  flex-direction: column;
  align-items: center;
  max-height: 100%;
}
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-panel {
  max-height: min(var(--votiq-panel-height), calc(var(--votiq-preview-h, 400px) - 8px)) !important;
}
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--left-middle,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--right-middle,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--left-bottom,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--right-bottom,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--bottom-right,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--bottom-left,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--top-right,
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-panel .votiq-stack--top-left {
  left: 50% !important;
  top: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
}
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-launcher {
  overflow: visible;
}
#votiq-widget-root.votiq-root--preview.votiq-root--preview-scope-launcher .votiq-stack {
  --votiq-preview-inset: 0;
}
#votiq-widget-root .votiq-help-screen {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 2px 8px;
}
#votiq-widget-root .votiq-help-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
}
#votiq-widget-root .votiq-help-context-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid rgba(170,247,117,0.45);
  background: rgba(170,247,117,0.14);
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #357200;
}
#votiq-widget-root .votiq-panel--dark .votiq-help-context-pill {
  color: #AAF775;
  border-color: rgba(170,247,117,0.35);
  background: rgba(170,247,117,0.12);
}
#votiq-widget-root .votiq-help-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
#votiq-widget-root .votiq-help-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid #EFF4FF;
  background: #fff;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 4px 16px -10px rgba(0,23,21,0.12);
  transition: border-color 0.15s, box-shadow 0.15s;
}
#votiq-widget-root .votiq-help-card:hover {
  border-color: rgba(170,247,117,0.55);
  box-shadow: 0 6px 20px -8px rgba(170,247,117,0.25);
}
#votiq-widget-root .votiq-panel--dark .votiq-help-card {
  border-color: rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.06);
  color: #fff;
}
#votiq-widget-root .votiq-help-card-icon {
  display: flex;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid rgba(170,247,117,0.35);
  background: rgba(170,247,117,0.12);
  color: #357200;
}
#votiq-widget-root .votiq-panel--dark .votiq-help-card-icon {
  color: #AAF775;
}
#votiq-widget-root .votiq-help-card-icon svg {
  width: 18px;
  height: 18px;
}
#votiq-widget-root .votiq-help-card-body {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}
#votiq-widget-root .votiq-help-card-kicker {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(65,72,71,0.7);
}
#votiq-widget-root .votiq-panel--dark .votiq-help-card-kicker {
  color: rgba(255,255,255,0.55);
}
#votiq-widget-root .votiq-help-card-title {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
}
#votiq-widget-root .votiq-help-card-summary {
  font-size: 11px;
  line-height: 1.45;
  color: rgba(65,72,71,0.85);
}
#votiq-widget-root .votiq-panel--dark .votiq-help-card-summary {
  color: rgba(255,255,255,0.65);
}
#votiq-widget-root .votiq-help-card-external {
  flex-shrink: 0;
  margin-top: 2px;
  color: rgba(65,72,71,0.45);
}
#votiq-widget-root .votiq-help-card-external svg {
  width: 14px;
  height: 14px;
}
#votiq-widget-root .votiq-help-empty {
  margin: 0;
  padding: 16px 8px;
  text-align: center;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(65,72,71,0.75);
}
#votiq-widget-root .votiq-panel--dark .votiq-help-empty {
  color: rgba(255,255,255,0.6);
}
#votiq-widget-root .votiq-help-empty--error {
  color: #b42318;
}
`;
